export const OR = 'OR';
export const AND = 'AND';
